(function() {
  function fixMenuOverlap() {
    var headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    var details = headerDrawer.querySelector('details');
    if (!details) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'open') {
          var isOpen = details.hasAttribute('open');
          document.body.classList.toggle('menu-is-open', isOpen);

          var sections = document.querySelectorAll('.shopify-section:not(.shopify-section-header)');
          sections.forEach(function(section) {
            if (isOpen) {
              section.style.setProperty('z-index', '-1', 'important');
              section.style.setProperty('position', 'relative', 'important');
              section.style.setProperty('pointer-events', 'none', 'important');
            } else {
              section.style.removeProperty('z-index');
              section.style.removeProperty('position');
              section.style.removeProperty('pointer-events');
            }
          });
        }
      });
    });

    observer.observe(details, { attributes: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMenuOverlap);
  } else {
    fixMenuOverlap();
  }
})();